import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";

import { dealTrackerApi } from "./apiSlices/dealTracker";
import { fxApi } from "./apiSlices/fxRate";
import { tradeFlowApi } from "./apiSlices/tradeFlow";
import { flowTemplatesApi } from "./apiSlices/flowTemplates";
import { emailManagementApi } from "./apiSlices/emailManagement";
import { commonApi } from "./apiSlices/common";
import { vendorContactsApi } from "./apiSlices/vendorContacts";
import { messagesApi } from "./apiSlices/messages";
import { containerTrackingApi } from "./apiSlices/containerTracking";
import { logisticesApi } from "./apiSlices/logistics";
import { partnerCompanyApi } from "./apiSlices/partnerCompany";
import { adminApi } from "./apiSlices/adminApi";
import { dealTrackerMailAlertApi } from "./apiSlices/dealTrackerMailAlert";
import { aiAutomateApi } from "./apiSlices/aiAutomate";
import { accessControlApi } from "./apiSlices/accessControl";
import { procurementAIApi } from "./apiSlices/procurementAI";

const allApiSlices = [
  dealTrackerApi,
  fxApi,
  tradeFlowApi,
  flowTemplatesApi,
  emailManagementApi,
  commonApi,
  vendorContactsApi,
  messagesApi,
  containerTrackingApi,
  logisticesApi,
  partnerCompanyApi,
  adminApi,
  dealTrackerMailAlertApi,
  aiAutomateApi,
  accessControlApi,
  procurementAIApi,
];

// Dynamically build reducers object
const apiReducers = allApiSlices.reduce(
  (acc, api) => ({ ...acc, [api.reducerPath]: api.reducer }),
  {},
);

// Configure store
export const store = configureStore({
  reducer: {
    ...apiReducers,
    // include any non-API reducers here if needed
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(allApiSlices.map((api) => api.middleware)),
  devTools: import.meta.env.DEV,
});

// Type helpers
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// Invalidate all API caches dynamically
export function invalidateApiCache() {
  allApiSlices.forEach((api) => {
    store.dispatch(api.util.resetApiState());
  });
}

// listener
// setupListeners(store.dispatch);

if (import.meta.env.PROD) {
  setupListeners(store.dispatch);
}
